import React from 'react';
import ClientSidebar from '../../components/ClientSidebar';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { useAuth } from '../../context/AuthContext';
import { mockInsurances } from '../../mock/mockData';
import { Shield, FileText, Heart, Home } from 'lucide-react';

const Insurance = () => {
  const { user } = useAuth();
  const userInsurances = mockInsurances.filter((i) => i.clientId === user?.id);

  return (
    <div className="flex">
      <ClientSidebar />
      <div className="flex-1 bg-gray-50">
        {/* Header */}
        <div className="bg-gray-800 text-white py-3 px-8 text-sm">
          Un crédit vous engage et doit être remboursé. Vérifiez vos capacités de remboursement avant de vous engager.
        </div>

        {/* Main Content */}
        <div className="max-w-6xl mx-auto p-8">
          <h1 className="text-2xl font-bold text-gray-900 mb-8">Mes assurances emprunteur</h1>

          {/* Borrower Insurance */}
          <div className="mb-12">
            <h2 className="text-xl font-semibold text-gray-900 mb-6">Mes assurances emprunteur</h2>
            <Card className="p-8">
              <div className="flex items-start space-x-6">
                <div className="p-4 rounded-full bg-purple-50">
                  <Shield className="h-12 w-12" style={{ color: '#8B5CF6' }} />
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Vente à Crédit</h3>
                  <p className="text-gray-600 mb-4">
                    Grâce à votre assurance, vous êtes protégé(e) contre les accidents de la vie
                  </p>
                  <p className="text-sm text-gray-500 mb-6">
                    Référence : 19 57605759117260
                  </p>
                  <Button
                    className="text-white font-medium"
                    style={{ backgroundColor: '#8B5CF6' }}
                  >
                    Gérer mon assurance
                  </Button>
                </div>
              </div>
            </Card>
          </div>

          {/* Property & Personal Insurance */}
          <div>
            <h2 className="text-xl font-semibold text-gray-900 mb-6">
              Mes assurances de biens et de personnes
            </h2>

            {/* Empty State Illustration */}
            <div className="text-center py-12 mb-8">
              <div className="inline-flex items-center justify-center w-32 h-32 mb-6">
                <img
                  src="https://illustrations.popsy.co/amber/charging-the-battery.svg"
                  alt="No insurance"
                  className="w-full h-full object-contain"
                />
              </div>
              <p className="text-gray-600 italic">C'est un peu vide ici...</p>
            </div>

            {/* Insurance Offers */}
            <Card className="p-8 bg-gradient-to-br from-teal-400 to-blue-500 text-white">
              <div className="grid md:grid-cols-2 gap-8">
                <div>
                  <h3 className="text-2xl font-bold mb-4">
                    Des assurances adaptées selon vos besoins
                  </h3>
                  <p className="mb-6">
                    Quels que soient vos projets, Younited vous permet de les réaliser en toute tranquillité et d'être protégé contre les aléas du quotidien.
                  </p>
                  <Button
                    className="bg-white hover:bg-gray-100"
                    style={{ color: '#8B5CF6' }}
                  >
                    Découvrir
                  </Button>
                </div>
                <div className="flex items-center justify-center">
                  <div className="relative">
                    <div className="w-48 h-48 bg-white/20 rounded-lg backdrop-blur-sm flex items-center justify-center">
                      <Heart className="h-24 w-24 text-white/80" />
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Insurance;
